// extracted by mini-css-extract-plugin
export default {"box":"liquidate_box__xZm1I","row1":"liquidate_row1__shNyu","total":"liquidate_total__WVl1n","header":"liquidate_header__PMGQn","internalBox":"liquidate_internalBox__6ks8v"};